import React, { forwardRef } from 'react';
import Proptypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => {
  return {
    root: props => ({
      position: 'absolute',
      borderTop: `solid 1px ${theme.palette.grey[100]}`,
      borderBottom: `solid 1px ${theme.palette.grey[100]}`,
      gridRow: '1',
      display: 'inline-grid',
      left: 0,
      right: 0,
      top: 0,
      fontSize: theme.typography.fontSize,
      color: theme.palette.grey[600],
      gridTemplateColumns: props.templateColumns,
      backgroundColor: theme.palette.common.white,
      boxSizing: 'border-box',
    }),
    spacer: props => ({
      height: props.height,
    }),
  };
});

const ListHeader = forwardRef(function ListHeader(
  { className, columnHeaders, templateColumns, height, ...restProps },
  ref
) {
  const classes = useStyles({ templateColumns, height });
  return (
    <>
      <div className={clsx(classes.root, className)} ref={ref} {...restProps}>
        {columnHeaders.map((headerColumn, i) => {
          const key = `list-header-${i}`;
          return <div key={key}>{headerColumn}</div>;
        })}
      </div>
      <div className={clsx(classes.spacer)} />
    </>
  );
});

ListHeader.propTypes = {
  className: Proptypes.string,
  columnHeaders: Proptypes.arrayOf(Proptypes.oneOfType([Proptypes.string, Proptypes.elementType]))
    .isRequired,
  templateColumns: Proptypes.string.isRequired,
  height: Proptypes.string.isRequired,
};

ListHeader.defaultProps = {
  className: null,
};

ListHeader.displayName = 'ListHeader';

export default ListHeader;
